import React from 'react'
import Head from '../layout/head.jsx'
import Content from '../layout/content.jsx'
import API from '../../services/api.jsx'
import Loader from '../layout/loader.jsx'
import {toast} from 'react-toastify'
import FileHandler from '../layout/file-handler/fileHandler'

class IntroductionEdit extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            breadcrumb: {title: 'Back to Introductions', path: '/introductions'},
            fields: {
                label: {label: 'Introduction name', type: 'text', required: true},
            },
            introduction: null
        }
    }

    createCorrectBannerUrl = (image) => {
        let urlPrefix = 'storage/introduction-banner/'

        let urlEnd = image.uri
        let url = urlPrefix + urlEnd

        image.uri = url
        return image
    }

    componentDidMount() {
        API.getIntroduction(this.props.match.params.introductionId).then(introduction => {
            var contentImages = []
            var bannerImage = {}
            var coverImage = {}

            if (introduction.banner) {
                bannerImage = this.createCorrectBannerUrl(introduction.banner)
            }

            if (introduction.cover) {
                coverImage = this.createCorrectCoverUrl(introduction.cover)
            }

            if (introduction.content.length === 0) {
                this.setState({
                    tempContentImages: contentImages,
                })
            } else {
                for (const i in introduction.content) {
                    contentImages[i] = {}
                }

                Object.keys(introduction.content).forEach(index => {
                    contentImages[index] = introduction.content[index]?.image?.uri ? this.createCorrectContentUrl(introduction.content[index]?.image) : null
                })

                this.setState({
                    tempContentImages: contentImages,
                })
            }

            this.setState({
                loading: false,
                introduction: introduction,
                tempBanner: bannerImage,
                tempCover: coverImage,
            })
        })
    }

    // Banner image
    showBannerImage = (file, fileObj, type, index) => {
        var introduction = this.state.introduction
        introduction.banner = this.createCorrectBannerUrl(fileObj)

        this.setState(previousState => ({
            introduction,
            tempBanner: introduction.banner
        }))
    }

    removeBannerImage = () => {
        this.setState(previousState => ({
            introduction: {
                ...this.state.introduction,
                banner: null
            },
            tempBanner: null,
        }))
    }

    createCorrectCoverUrl = (image) => {
        let urlPrefix = 'storage/introduction-cover/'

        let urlEnd = image.uri
        let url = urlPrefix + urlEnd

        image.uri = url
        return image
    }

    // Cover image
    showCoverImage = (file, fileObj, type, index) => {
        var introduction = this.state.introduction
        introduction.cover = this.createCorrectCoverUrl(fileObj)

        this.setState(previousState => ({
            introduction,
            tempCover: introduction.cover
        }))
    }

    removeCoverImage = () => {
        this.setState(previousState => ({
            introduction: {
                ...this.state.introduction,
                cover: null
            },
            tempCover: null,
        }))
    }

    // Content block
    addContentBlock = () => {
        const content = this.state.introduction.content

        const newBlock = {
            title: {
                en: '',
                zh: ''
            },
            description: {
                en: '',
                zh: ''
            },
            image: null
        }

        const newBlocks = [...content, newBlock]

        this.setState({
            introduction: {
                ...this.state.introduction,
                content: newBlocks
            }
        })
    }

    removeContentBlock = (index) => {
        var r = window.confirm("Are you sure you want to delete this block?");
        if (r === false) return

        let content = this.state.introduction.content

        content.splice(index, 1)

        this.setState(prevState => ({
            ...prevState,
            content
        }))
    }

    createCorrectContentUrl = (image) => {
        let urlPrefix = 'storage/introduction-image/'

        let urlEnd = image.uri
        let url = urlPrefix + urlEnd

        image.uri = url

        return image
    }

    // Content images
    showContentImages = (file, fileObj, type, index) => {
        var images = this.state.tempContentImages

        var introduction = this.state.introduction
        introduction.content[index].image = fileObj

        // Create a correct url for the new file
        var tempFile = this.createCorrectContentUrl(fileObj)
        images[index] = tempFile

        this.setState({
            introduction,
            tempContentImages: images
        })
    }
    
    removeContentImage = (index, type) => {
        const tempContentImages = {...this.state.tempContentImages}
        const introduction = {...this.state.introduction}

        tempContentImages[index] = null
        introduction.content[index][type] = null

        const images = tempContentImages

        this.setState({
            introduction,
            tempContentImages: images
        })
    }

    handleChange = (e, element, subElement, lang, index = 0) => {
        var newValue = e
        let {introduction} = this.state

        if (element === 'content') {
            introduction[element][index][subElement][lang] = newValue
        } else {
            if (lang == '') {
                introduction[element][subElement] = newValue
            } else {
                introduction[element][subElement][lang] = newValue
            }
        }

        this.setState(previousState => ({
            ...previousState,
            introduction
        }))
    }

    updateField(e, key) {
        this.setState({
            introduction: {
                ...this.state.introduction,
                [key]: e.target.value
            }
        })
    }

    saveEntity = (updatedEntity) => {
        this.setState({loading: true})

        if (!this.state.introduction.name?.en || !this.state.introduction.name?.zh) {
            toast.error('Introduction\'s name can not be empty')
            this.setState({loading: false})
            return
        } else if (!updatedEntity.banner) {
            toast.error('Introduction\'s banner can not be empty')
            this.setState({loading: false})
            return
        } else if (!updatedEntity.cover) {
            toast.error('Introduction\'s cover can not be empty')
            this.setState({loading: false})
            return
        }

        for (const i in updatedEntity.content) {
            if (!updatedEntity.content[i].image) {
                toast.error('Introduction\'s image can not be empty')
                this.setState({loading: false})
                return
            }
        }

        let bannerUri = updatedEntity.banner.uri.replace('storage/introduction-banner/', '')
        updatedEntity.banner.uri = bannerUri

        let coverUri = updatedEntity.cover.uri.replace('storage/introduction-cover/', '')
        updatedEntity.cover.uri = coverUri

        updatedEntity.content.map(c => {
            if (c.image) {
                c.image.uri = c.image.uri.replace('storage/introduction-image/', '')
            }
        })

        API.update('introductions', this.props.match.params.introductionId, updatedEntity).then(() => {
            toast.success('Introduction has been updated')
            this.props.history.push('/introductions')
        }).catch(() => {
            toast.error('An unexpected error has occured, please try again')
            this.setState({loading: false})
        })
    }

    deleteEntity = () => {
        var r = window.confirm("Are you sure you want to delete this introduction?");
        if (r === false) return

        this.setState({loading: true})
        API.deleteIntroduction(this.props.match.params.introductionId).then(() => {
            toast.success('Introduction was successfully deleted')
            this.props.history.push('/introductions')
        }).catch(() => {
            toast.error('An unexpected error has occured, please try again')
            this.setState({loading: false})
        })
    }

    onCancel(e, callback) {
        e.preventDefault()
        callback()
    }

    onSubmit(e, callback) {
        e.preventDefault()
        callback()
    }

    render() {
        if (this.state.loading)
            return <Loader/>
        else
            return <>
                <Head title={'Edit introduction'}/>
                <Content>
                    <form onSubmit={(e) => {
                        this.onSubmit(e, () => this.saveEntity(this.state.introduction))
                    }} className="custom-form">
                        <div className="actions clearfix">
                            <div className="buttons clearfix">
                                <button className="grey"
                                        onClick={(e) => this.onCancel(e, () => this.props.history.push('/introductions'))}>Cancel
                                </button>
                                <button className="blue">Save introduction</button>
                            </div>
                        </div>

                        <div className="block above">
                            <div className="fields container clearfix">
                                <h3>Information</h3>
                                <div className="field" key="nameEn">
                                    <label>Name in English</label>
                                    <input type="text"
                                           onChange={(e) => this.handleChange(e.target.value, 'name', 'en', '')}
                                           value={this.state.introduction?.name?.en || ""}/>
                                </div>
                                <div className="field" key="nameZh">
                                    <label>Name in Chinese</label>
                                    <input type="text"
                                           onChange={(e) => this.handleChange(e.target.value, 'name', 'zh', '')}
                                           value={this.state.introduction?.name?.zh || ""}/>
                                </div>
                                <div className="field" key="banner">
                                    <div className="file-handler-container">
                                        {this.state.tempBanner &&
                                        <FileHandler
                                            image={this.state.tempBanner.uri}
                                            name={this.state.tempBanner.name}
                                            removeImage={(type) => this.removeBannerImage(type)}
                                            type={'images'}
                                            label={'Banner'}
                                            fileType={'images'}
                                            path={'introduction-banner'}
                                        />
                                        }

                                        {!this.state.tempBanner &&
                                        <FileHandler
                                            showImage={this.showBannerImage}
                                            type={'images'}
                                            label={'Banner'}
                                            fileType={'images'}
                                            path={'introduction-banner'}
                                            dropzone
                                        />
                                        }
                                    </div>
                                </div>
                                <div className="field" key="cover">
                                    <div className="file-handler-container">
                                        {this.state.tempCover &&
                                        <FileHandler
                                            image={this.state.tempCover.uri}
                                            name={this.state.tempCover.name}
                                            removeImage={(type) => this.removeCoverImage(type)}
                                            type={'images'}
                                            label={'Cover'}
                                            fileType={'images'}
                                            path={'introduction-cover'}
                                        />
                                        }

                                        {!this.state.tempCover &&
                                        <FileHandler
                                            showImage={this.showCoverImage}
                                            type={'images'}
                                            label={'Cover'}
                                            fileType={'images'}
                                            path={'introduction-cover'}
                                            dropzone
                                        />
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className="fields container clearfix">
                                <h3>Content</h3>

                                {
                                    Object.keys(this.state.introduction.content).map(index => {
                                        return (
                                            <div className="fields container clearfix">
                                                <div>
                                                    <p style={{
                                                        textDecoration: 'underline'
                                                    }}>{parseInt(index) + 1}. Block {parseInt(index) + 1}
                                                    </p>
                                                    <label style={{
                                                        textDecorationLine: 'underline',
                                                        color: '#2196F3',
                                                        position: 'absolute',
                                                        right: '32px',
                                                        cursor: 'pointer'
                                                    }}
                                                           onClick={() => {
                                                               this.removeContentBlock(index)
                                                           }}
                                                    >Delete
                                                    </label>
                                                </div>

                                                <div className="field" key="titleEn">
                                                    <label>Title in English</label>
                                                    <input type="text"
                                                           onChange={(e) => this.handleChange(e.target.value, 'content', 'title', 'en', index)}
                                                           value={this.state.introduction?.content[index].title.en || ""}/>
                                                </div>

                                                <div className="field" key="titleZh">
                                                    <label>Title in Chinese</label>
                                                    <input type="text"
                                                           onChange={(e) => this.handleChange(e.target.value, 'content', 'title', 'zh', index)}
                                                           value={this.state.introduction?.content[index].title.zh || ""}/>
                                                </div>

                                                <div className="field" key="image">
                                                    <div className="file-handler-container">
                                                        {this.state.tempContentImages[index] &&
                                                            <FileHandler
                                                                image={this.state.tempContentImages[index].uri}
                                                                name={this.state.tempContentImages[index].name}
                                                                removeImage={(type) => this.removeContentImage(index, type)}
                                                                type={'image'}
                                                                label={'Image'}
                                                                fileType={'images'}
                                                                path={'introduction-image'}
                                                                index={index}
                                                            />
                                                        }

                                                        {!this.state.tempContentImages[index] &&
                                                            <FileHandler
                                                                showImage={this.showContentImages}
                                                                type={'images'}
                                                                label={'Image'}
                                                                fileType={'images'}
                                                                path={'introduction-image'}
                                                                index={index}
                                                                dropzone
                                                            />
                                                        }
                                                    </div>
                                                </div>

                                                <div className="long-field" key="descriptionEn">
                                                    <label>Description in English</label>
                                                    <textarea type="text"
                                                              onChange={(e) => this.handleChange(e.target.value, 'content', 'description', 'en', index)}
                                                              value={this.state.introduction?.content[index].description.en || ""}
                                                    />
                                                </div>

                                                <div className="long-field" key="descriptionZh">
                                                    <label>Description in Chinese</label>
                                                    <textarea type="text"
                                                              onChange={(e) => this.handleChange(e.target.value, 'content', 'description', 'zh', index)}
                                                              value={this.state.introduction?.content[index].description.zh || ""}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    })
                                }

                                <div className="buttons">
                                    <button className="blue add clearfix"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.addContentBlock()
                                            }}>
                                        Add new block
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div className="actions clearfix below-form">
                        <button onClick={() => this.deleteEntity()} className="red">Delete introduction</button>
                    </div>
                </Content>
            </>
    }
}

export default IntroductionEdit